/**
 * buildMeta.js — RC 1.55 Phase Z.4 (operator-locked, 2026-05-13 PM)
 *
 * Single source of truth for the bundle-version string emitted on
 * the `X-Ndor-Bundle-Version` telemetry header. Bumped manually
 * each time a Phase Z.* (or later) frontend change ships so the
 * ADAPTER_INPUT_ERROR forensic log can distinguish a stale bundle
 * from a current one without ambiguity.
 *
 * Hard rails:
 *   • READ-ONLY constant. No runtime side-effects.
 *   • Telemetry only — never read by billing / orchestration /
 *     idempotency / charge paths.
 *   • String literal so webpack tree-shaking inlines it at build
 *     time. The value the user's preview tab is running is
 *     therefore exactly what the source file says at deploy time.
 */
export const BUNDLE_VERSION = 'rc-1-55-z4-2026-05-13';

export default BUNDLE_VERSION;
